export function guid() {
  let r, v;

  return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, (c) => {
    (r = (Math.random() * 16) | 0), //eslint-disable-line
      (v = c === "x" ? r : (r & 0x3) | 0x8);

    return v.toString(16);
  });
}

export function shortGuid(length = 10) {
  let longGuid = guid();

  return longGuid.replace("-", "").substr(0, length).toUpperCase();
}
